<ejs-dialog showCloseIcon="true" #ejDialogConfirmDownload cssClass="fn-dl-dialog"
  (overlayClick)="onOverlayClickOutsideMenu()" 
  (beforeClose)="onDialogClose($event)"
  [width]="dialogWidth" [visible]="isVisible"
  [animationSettings]='animationSettings' [target]="dialogDragTarget"
  [allowDragging]='allowDialogDragging' [enableResize]='false' isModal="true"
  [zIndex]="110090">
  <ng-template #header>
    <div class="fn-dl-title">Download Notebook</div>
    <div class="fn-dl-subtitle" [attr.title]="formatLabel">{{formatLabel}}</div>
  </ng-template>
  <div>
    <div class="section">
    <div *ngIf="downloadNotebookName != ''"><span class="titleInline">{{downloadNotebookName}}</span><br></div>
    <span class="titleInline">NotebookID:</span><span class="details">{{downloadNotebookbookID}}</span><br>
    <span class="titleInline">File Size:</span><span class="details">{{downloadFileSizeDisplayMB}}</span><br>
    <div *ngIf="showSizeWarning">
      <p class="note">NOTE: This file could take several minutes to download depending on your internet download speed.</p>
    </div>
    <p>&nbsp;</p>
  </div>
    <div class="centerDiv"><button  [disabled]="isDisabled" downloadFile="{{downloadURL}}" 
        fileName="{{fileName}}" (click)="onClickDownload()" title="Click to download" 
        (downloadProgress)="onDownloadProgress($event)" (downloadComplete)="onDownloadComplete($event)"
        (downloadError)="onDownloadError($event)"
        class="success"><img
        src="/assets/images/progress-spinner.gif" class="button-spinner"
        *ngIf="isSpinnerActive" />{{downloadButtonLabel}}</button>
        <div *ngIf="downloadComplete" class="downloadInfo">Saved to your browser download area.</div>
    </div>
  </div>
</ejs-dialog>